import { CALL_API } from '../middleware/ApiMiddleware';

export const EXECUTIVE_REPORTS_LIST_FETCH_REQUEST = 'EXECUTIVE_REPORTS_LIST_FETCH_REQUEST';
export const EXECUTIVE_REPORTS_LIST_FETCH_SUCCESS = 'EXECUTIVE_REPORTS_LIST_FETCH_SUCCESS';
export const EXECUTIVE_REPORTS_LIST_FETCH_FAILURE = 'EXECUTIVE_REPORTS_LIST_FETCH_FAILURE';

export const EXECUTIVE_REPORT_EMBED_URL_FETCH_REQUEST = 'EXECUTIVE_REPORT_EMBED_URL_FETCH_REQUEST';
export const EXECUTIVE_REPORT_EMBED_URL_FETCH_SUCCESS = 'EXECUTIVE_REPORT_EMBED_URL_FETCH_SUCCESS';
export const EXECUTIVE_REPORT_EMBED_URL_FETCH_FAILURE = 'EXECUTIVE_REPORT_EMBED_URL_FETCH_FAILURE';

const baseURL = 'agencies/executive-reports';

export const getExecutiveReportsList = (productType: ConfigProductType) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    params: {
      productType,
    },
    types: [
      EXECUTIVE_REPORTS_LIST_FETCH_REQUEST,
      EXECUTIVE_REPORTS_LIST_FETCH_SUCCESS,
      EXECUTIVE_REPORTS_LIST_FETCH_FAILURE,
    ],
  },
});

export const getExecutiveReportEmbedURL = (
  executiveReportId: number,
  productType: ConfigProductType,
  timezoneOffset: number
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${executiveReportId}/embed-url`,
    method: 'get',
    authenticated: true,
    params: {
      productType,
      timezoneOffset,
    },
    types: [
      EXECUTIVE_REPORT_EMBED_URL_FETCH_REQUEST,
      EXECUTIVE_REPORT_EMBED_URL_FETCH_SUCCESS,
      EXECUTIVE_REPORT_EMBED_URL_FETCH_FAILURE,
    ],
  },
});
